// Shared keys for the app's two Blackbaud Merchant Services accounts, so no
// one hard-codes 'donation'/'event' strings. These aren't meaningful to BBMS;
// they're just how every caller looks up the right payment configuration ID in
// `src/config.js` --> `config.blackbaudCheckout.paymentConfigurationIds`.
export const oBbMerchantAccount = Object.freeze({
  donation: 'donation',
  event: 'event',
});

export default {};
